<div
  class="empty-state-container"
  [class.empty-state-container--card]="variant === 'card'"
  role="status"
  aria-live="polite"
  [attr.data-testid]="testId"
>
  <div class="empty-state-content">
    <img *ngIf="image" class="empty-state-image" [src]="image" [alt]="imageAlt" />

    <h3 *ngIf="title" class="empty-state-title" [attr.data-testid]="testId + '-title'">
      {{ title }}
    </h3>
    <p
      *ngIf="description"
      class="empty-state-description"
      [attr.data-testid]="testId + '-description'"
    >
      {{ description }}
    </p>

    <div class="empty-state-action" *ngIf="showAction && actionLabel">
      <button
        type="button"
        class="btn btn-primary btn-medium"
        [attr.data-testid]="testId + '-action-button'"
        (click)="onAction()"
      >
        <img *ngIf="actionIcon; else plusGlyph" [src]="actionIcon" alt="" aria-hidden="true" />
        <ng-template #plusGlyph>
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true">
            <path
              d="M7.49935 1.66675V13.3334M1.66602 7.50008H13.3327"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </ng-template>
        {{ actionLabel }}
      </button>
    </div>
  </div>
</div>
